export enum Themes
{
    None,
    Bootstrap
}